import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IItemVariation } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ItemVariationService extends BaseService<IItemVariation> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'itemVariation');
  }
}

export { IItemVariation } from '../shared/api';
